import { computeFieldDimensionsBibliographie } from "@/lib/computeFields";
import { AdvancedSearchConfig } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";
import i18n, { SupportedLocale } from "@/i18n";

export const bibliographyColumns: ColumnFormatted[] = [
  {
    type: "string",
    key: "bibliographieDescriptionNumeroBibliographie",
    visible: true,
  },
  { type: "image", key: "vignette", visible: true },
  { type: "string", key: "bibliographieDescriptionAnnee", visible: true },
  { type: "string", key: "bibliographieDescriptionType", visible: true },
  {
    type: "boolean",
    key: "bibliographieDescriptionIllustrations",
    visible: false,
  },
  { type: "string", key: "bibliographieDescriptionAuteur", visible: true },
  { type: "string", key: "bibliographieDescriptionTitre", visible: true },
  {
    type: "string",
    key: "bibliographieDescriptionTitreDOrigine",
    visible: false,
  },
  { type: "string", key: "bibliographieDescriptionSousTitre", visible: false },
  { type: "string", key: "bibliographieDescriptionCollection", visible: false },
  { type: "string", key: "bibliographieDescriptionEditeur", visible: false },
  { type: "string", key: "bibliographieDescriptionVille", visible: false },
  { type: "string", key: "bibliographieDescriptionPays", visible: false },
  { type: "string", key: "bibliographieDescriptionNomRevue", visible: false },
  {
    type: "string",
    key: "bibliographieDescriptionNumeroRevue",
    visible: false,
  },
  {
    type: "string",
    key: "bibliographieDescriptionPageArticle",
    visible: false,
  },
  {
    type: "string",
    key: "bibliographieDescriptionDatesPublication",
    visible: false,
  },
  {
    type: "richtext",
    key: "bibliographieDescriptionResumeLong",
    visible: false,
  },
  {
    type: "richtext",
    key: "bibliographieDescriptionResumeCourt",
    visible: false,
  },
  { type: "richtext", key: "bibliographieDescriptionNotes", visible: false },
  {
    type: "string",
    key: "bibliographieDescriptionLocalisationReference",
    visible: false,
  },
  {
    type: "string",
    key: "bibliographieDescriptionRangementReference1",
    visible: false,
  },
  {
    type: "string",
    key: "bibliographieDescriptionRangementReference2",
    visible: false,
  },
  {
    type: "computed",
    key: "bibliographieDescriptionDimensions",
    formattedData: (data: any) =>
      computeFieldDimensionsBibliographie(data, {
        language: i18n.language as SupportedLocale,
      }),
    visible: false,
  },
  {
    type: "string",
    key: "bibliographieDescriptionNombrePages",
    visible: false,
  },
  { type: "string", key: "bibliographieDescriptionContexture", visible: false },
  { type: "string", key: "bibliographieDescriptionCouverture", visible: false },
  { type: "string", key: "bibliographieDescriptionIsbn", visible: false },
  {
    type: "string",
    key: "bibliographieDescriptionAutreCodeBibliographie",
    visible: false,
  },
  {
    type: "boolean",
    key: "bibliographieValidationReprosOeuvresOk",
    visible: false,
  },
  {
    type: "boolean",
    key: "bibliographieValidationReprosPhotosOk",
    visible: false,
  },
  {
    type: "boolean",
    key: "bibliographieValidationReprosDocumentsOk",
    visible: false,
  },
  {
    type: "boolean",
    key: "bibliographieValidationListeDesOeuvresOk",
    visible: false,
  },
  {
    type: "boolean",
    key: "bibliographieValidationPublicationNumerisee",
    visible: false,
  },
  { type: "boolean", key: "bibliographieValidationPdfEtOcrOk", visible: false },
  {
    type: "boolean",
    key: "bibliographieValidationNoticeBibliographiqueOk",
    visible: false,
  },
  { type: "richtext", key: "sources", visible: false },
  { type: "status", key: "bibliographiePublicationStatus", visible: true },
];

export const bibliographyAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "bibliographieDescription",
    fields: [
      { type: "string", key: "bibliographieDescriptionNumeroBibliographie" },
      { type: "string", key: "bibliographieDescriptionAuteur" },
      { type: "string", key: "bibliographieDescriptionAnnee" },
      { type: "string", key: "bibliographieDescriptionTitre" },
      { type: "string", key: "bibliographieDescriptionTitreDOrigine" },
      { type: "string", key: "bibliographieDescriptionSousTitre" },
      { type: "string", key: "bibliographieDescriptionType" },
      { type: "boolean", key: "bibliographieDescriptionIllustrations" },
      { type: "string", key: "bibliographieDescriptionCollection" },
      { type: "string", key: "bibliographieDescriptionEditeur" },
      { type: "string", key: "bibliographieDescriptionVille" },
      { type: "string", key: "bibliographieDescriptionPays" },
      { type: "string", key: "bibliographieDescriptionNomRevue" },
      { type: "string", key: "bibliographieDescriptionNumeroRevue" },
      { type: "string", key: "bibliographieDescriptionDatesPublication" },
      { type: "string", key: "bibliographieDescriptionPageArticle" },
      { type: "string", key: "bibliographieDescriptionNombrePages" },
      { type: "string", key: "bibliographieDescriptionContexture" },
      { type: "string", key: "bibliographieDescriptionCouverture" },
      { type: "string", key: "bibliographieDescriptionIsbn" },
      { type: "string", key: "bibliographieDescriptionAutreCodeBibliographie" },
      { type: "boolean", key: "bibliographieValidationReprosOeuvresOk" },
      { type: "boolean", key: "bibliographieValidationReprosPhotosOk" },
      { type: "boolean", key: "bibliographieValidationReprosDocumentsOk" },
      { type: "boolean", key: "bibliographieValidationListeDesOeuvresOk" },
      { type: "boolean", key: "bibliographieValidationPublicationNumerisee" },
      { type: "boolean", key: "bibliographieValidationPdfEtOcrOk" },
      {
        type: "boolean",
        key: "bibliographieValidationNoticeBibliographiqueOk",
      },
      { type: "string", key: "bibliographieDescriptionResumeCourt" },
      { type: "string", key: "bibliographieDescriptionResumeLong" },
      { type: "string", key: "bibliographieDescriptionNotes" },
      { type: "string", key: "bibliographieDescriptionLocalisationReference" },
      { type: "string", key: "bibliographieDescriptionRangementReference1" },
      { type: "string", key: "bibliographieDescriptionRangementReference2" },
    ],
  },
  {
    type: "group",
    label: "sources",
    fields: [{ type: "string", key: "sources" }],
  },
];
